import actionTypes from '../../actionTypes'
import initial from '../../initial'

const onboarding = (state = initial.onboarding, action) => {
  switch (action.type) {
    case actionTypes.SET_ONBOARDING_PROCESS:
      return { ...state, onboardingProcess: action.payload }
    case actionTypes.SET_RELOAD_ONBOARDING:
      return { ...state, reloadOnboarding: action.payload }
    case actionTypes.SET_WELCOME_VISIBLE:
      return { ...state, welcomeVisible: action.payload }
    case actionTypes.SET_WELCOME_BUSINESS_VISIBLE:
      return { ...state, welcomeBusinessVisible: action.payload }
    case actionTypes.SET_TUTORIAL_PROCESS:
      return { ...state, tutorialProcess: action.payload }
    case actionTypes.SET_SHOW_TUTORIAL:
      return { ...state, showTutorial: action.payload }
    case actionTypes.SET_TUTORIAL_RUNNING:
      return { ...state, tutorialRunning: action.payload }
    case actionTypes.SET_STEP_INDEX:
      return { ...state, stepIndex: action.payload }
    case actionTypes.SET_TUTORIAL_DETAIL_RUNNING:
      return { ...state, tutorialDetailRunning: action.payload }
    case actionTypes.SET_STEP_DETAIL_INDEX:
      return { ...state, stepDetailIndex: action.payload }
    case actionTypes.SET_GET_EXTENSION_VISIBLE:
      return { ...state, getExtensionVisible: action.payload }
    default:
      return state
  }
}

export default onboarding
